import styledC from 'styled-components';
import theme from '@adsk/alloy-react-theme';
const MenuGroupHeader = styledC.p.withConfig({
  displayName: "MenuGroupHeader",
  componentId: "sc-1645h6v-0"
})(["display:flex;align-items:center;margin:0px;padding-left:", "px;height:32px;background:", ";color:inherit;", ""], theme.spacing.M, theme.tokens.colors.background.secondary.value, theme.typography.bodySmall);
MenuGroupHeader.displayName = 'MenuGroupHeader';
export default MenuGroupHeader;
//# sourceMappingURL=MenuGroupHeader.js.map